// extracted by mini-css-extract-plugin
export default {"DestinationInfoComponent":"DestinationInfoComponent_DestinationInfoComponent__MTI5Z"};